module.exports = __webpack_public_path__ + "img/filter-right.08eb520b.svg";